import { useState, useEffect, useContext } from "react";
import { auth } from "../fireconnection";
import { onAuthStateChanged } from "firebase/auth";
import { Navigate } from "react-router-dom";
import { UserContext } from "../contexts/user";

export default function Private({children}) {

    const {setUserDoContext} = useContext(UserContext)

    const [loading, setLoading] = useState(true);
    const [signed, setSigned] = useState(false);

    useEffect(()=>{
        async function checkLogin() {
            const unsub = onAuthStateChanged(auth, user => {
                if(user){
                    const userData = {
                        uid: user.uid,
                        email: user.email,
                    }
                    // localStorage.setItem('@detailUser', JSON.stringify(userData));
                    setUserDoContext(userData);

                    setLoading(false);
                    setSigned(true);

                }else{
                    setLoading(false);
                    setSigned(false);
                }
            })
        }

        checkLogin()

    }, [setUserDoContext])

    if(loading){
        return(
            <div></div>
        )
    }

    if(!signed){
        return <Navigate to='/' />
    }
    return children
}